import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AlertError from '../AlertError';
import Popup from '../Popup';
import * as types from '../../../redux/actionTypes/errorActionTypes';
import './PopupError.less';

class PopupError extends Component {
  onClose = () => {
    this.props.dispatch({
      type: types.RESET_VALIDATION_ERROR,
    });
  }

  render() {
    if (this.props.popupErrors) {
      return (
        <Popup show
               clsName="alias-error"
               topBarTitle="Reminder!"
               onClose={this.onClose}>
          <div className="error-text">
            { this.props.popupErrors.messages }
          </div>
        </Popup>
      );
    }
    if (this.props.alertErrors) {
      return (
        <AlertError errors={this.props.errors} />
      );
    }
    return null;
  }
}

PopupError.defaultProps = {
  errors: null,
  popupErrors: null,
  alertErrors: null,
};

PopupError.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.any,
  popupErrors: PropTypes.any,
  alertErrors: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    popupErrors: state.get('validationErrors') ? state.get('validationErrors').toJS() : null,
    alertErrors: state.get('searchErrors') ? state.get('searchErrors').toJS() : null,
  };
}

export default connect(mapStateToProps)(PopupError);



// WEBPACK FOOTER //
// ./src/components/common/PopupErrorComponent/PopupError.jsx